<template>
  <div class="article_detail">
    <div
      class="detail"
      v-if='articleDetail.hasOwnProperty("id")'
    >

      <div class="page_flag">
        <div
          class="flag_orign_button"
          v-if='articleDetail.flag_origin && articleDetail.doc_type !== "document"'
        >原创</div>

        <div
          style="background:#02AAFF;"
          class="flag_orign_button"
          v-if='articleDetail.doc_type == "picture"'
        >图集</div>

        <div
          class="flag_orign_button"
          :class="[articleDetail.flag_origin ? 'has_submit_button':'']"
          v-if='articleDetail.flag_submit && articleDetail.doc_type !== "document"'
        >已投</div>
      </div>

      <div
        class="detail_title"
        v-if='articleDetail.doc_type !== "document"'
      >{{articleDetail.title}}</div>

      <div
        class="detail_info"
        v-if='articleDetail.doc_type !== "document"'
      >

        <div class="base_field">
          <div class="each_base_field">
            <span class="base_field_title">作者：</span>
            <span class="base_field_content">{{ articleDetail.author }}</span>
          </div>
          <div
            class="each_base_field"
            v-for="(item,index) in baseinfoRoleKey"
            v-show="isShowCurrentFiled(item)"
            :key="index"
          >
            <span class="base_field_title">{{ item.desc }}：</span>
            <span class="base_field_content">{{ articleDetail[item.key]}}</span>
          </div>
        </div>

        <div class="pack_up">
          <div
            class="every_info"
            style="padding-top:0px;"
          >
            <span
              style="margin-left:0px;"
              class="every_info_title"
            >更新时间：</span>
            <span class="every_info_label">{{ articleDetail.time_update | formatTime }}</span>
            <span class="every_info_title">创建时间：</span>
            <span class="every_info_label">{{ articleDetail.time_create | formatTime }}</span>
          </div>
        </div>
        <div class="every_info">
          <span
            class="every_info_title"
            style="margin-left:0px;"
          >稿件状态</span>：
          <span class="value msp_state">
            <span
              style="color:#6BD57C;"
              v-if='articleDetail.hasOwnProperty("id") && articleDetail.audit_status === "yes"'
            >已通过</span>
            <span
              style="color:#F56969;"
              v-if='articleDetail.hasOwnProperty("id") && articleDetail.audit_status === "no"'
            >未通过</span>
            <span
              style="color:#FFAD2F;"
              v-if='articleDetail.hasOwnProperty("id") && articleDetail.audit_status === "doing"'
            >审核中</span>
            <span
              style="color:#aaa;"
              v-if='articleDetail.hasOwnProperty("id") && articleDetail.audit_status === "unAudit"'
            >未审核</span>

          </span>
          <span class="value msp_state">
            <span
              style="color:#6BD57C;"
              v-if='articleDetail.hasOwnProperty("id") && articleDetail.flag_use'
            >已采用</span>
            <span
              style="color:#aaa;"
              v-if='articleDetail.hasOwnProperty("id") && !articleDetail.flag_use'
            >未采用</span>
          </span>
          <span class="value msp_state">
            <span
              style="color:#6BD57C;"
              v-if='articleDetail.hasOwnProperty("id") && articleDetail.flag_push === "yes"'
            >已推送</span>
            <span
              style="color:#aaa;"
              v-if='articleDetail.hasOwnProperty("id") && articleDetail.flag_push === "no"'
            >未推送</span>
            <span
              style="color:#FFFFFF;background-color:#F56969"
              v-if='articleDetail.hasOwnProperty("id") && articleDetail.flag_cancel_push'
            >已撤搞</span>
          </span>

        </div>

        <div class="pack_up">
          <div class="every_info">
            <span
              style="margin-left:0px;"
              class="every_info_title"
            >稿件位置：</span>
            <span class="every_info_label">{{ articleDetail.target_location }}</span>
          </div>
        </div>

      </div>

      <div
        class="analyze"
        v-if='articleDetail.doc_type !== "document"'
      >
        <div
          class="every_info"
          v-if="isShowOtherFileds('source')"
        >
          <span class="every_info_title">稿件来源：</span>
          <div class="every_info_content">
            <span class="every_info_label">{{ articleDetail.source }}</span>
          </div>

          <span
            class="every_info_title"
            v-if="articleDetail && articleDetail.submit_c_name"
          >投递单位：</span>
          <div
            class="every_info_content"
            v-if="articleDetail && articleDetail.submit_c_name"
          >
            <span class="every_info_label">{{ articleDetail.submit_c_name }}</span>
          </div>

          <span v-if="articleDetail && articleDetail.submit_u_name">投递人：</span>
          <div
            class="every_info_content"
            v-if="articleDetail && articleDetail.submit_u_name"
          >
            <span class="every_info_label">{{ articleDetail.submit_u_name }}</span>
          </div>

        </div>

        <div
          class="every_info"
          v-if="isShowOtherFileds('reporter')"
        >
          <span class="label big_width_label every_info_title">记者</span>：
          <div class="every_info_content">
            <span
              class="every_info_label"
              v-for="(item,index) in articleDetail.reporters"
              :key="index"
            >{{item.username}} &nbsp;&nbsp;</span>
          </div>
        </div>

        <div
          class="every_info"
          v-if="isShowOtherFileds('keywords')"
        >
          <span class="label big_width_label every_info_title">关键词</span>：
          <div class="every_info_content">
            <span
              class="every_info_label"
              v-for="(item,index) in articleDetail.keywords"
              :key="index"
            >{{item}} &nbsp;&nbsp;</span>
          </div>
        </div>
        <div
          class="every_info"
          v-if="isShowOtherFileds('tags')"
        >
          <span class="label big_width_label every_info_title">标签</span>：
          <div class="every_info_content">
            <span
              class="every_info_label"
              v-for="(item,index) in articleDetail.tags"
              :key="index"
            >{{ item }} &nbsp;&nbsp;</span>
          </div>
        </div>
        <div
          class="every_info"
          v-if="isShowOtherFileds('summary')"
        >
          <span class="every_info_title">稿件摘要：</span>
          <div class="every_info_content">
            <span style="color: #909399">{{ articleDetail.summary }}</span>
          </div>

        </div>

        <div
          class="every_info"
          v-if="isShowOtherFileds('dialogue_text')"
        >
          <span class="every_info_title">稿件口播：</span>
          <div class="every_info_content">
            <span style="color: #909399">{{ articleDetail.dialogue_text }}</span>
          </div>

        </div>

        <div
          class="every_info"
          v-if="isShowOtherFileds('material_name')"
        >
          <span class="every_info_title">素材名称：</span>
          <div class="every_info_content">
            <span style="color: #909399">{{ articleDetail.material_name }}</span>
          </div>

        </div>

        <div class="every_info">
          <span class="every_info_title">稿件头图：</span>
          <div
            v-for="src in articleDetail.list_header_img"
            :key="src"
            class="article_header_img"
            style=" margin-right:20px;margin-left:10px;"
          >
            <el-image
              style="width: 90px; height: 64px"
              :src="src"
              :alt='alt'
              :fit="fit"
              class="el-image-class"
            >
              <div
                slot="error"
                class="image-slot"
              >
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>

        </div>
      </div>

      <div class="article_detail_content froala_editor fr-box fr-document fr-ltr fr-basic fr-top">
        <div class="fr-wrapper">
          <div
            v-if="articleDetail.doc_type !=='picture' && articleDetail.doc_type !=='outer_chain'"
            class="detail-content fr-element fr-view"
            style="padding:30px 50px 30px 50px;"
            v-html='articleDetail.content'
          >
          </div>

          <div
            v-if="articleDetail.doc_type === 'picture'"
            class="detail-content detail-picture-content fr-element fr-view"
            style="padding:30px 50px 30px 50px;"
          >
            <div
              class="each_detail_picture"
              v-for="(item,index) in articleDetail.list_pic_doc"
              :key="index"
            >
              <div class="each_detail_picture_img">
                <img
                  :src="item.url"
                  alt=""
                >
              </div>

              <div class="each_detail_picture_descrip">
                <span>{{item.mark}}</span>
              </div>

            </div>
          </div>

          <div
            v-if="articleDetail.doc_type === 'outer_chain'"
            class="detail-content detail-picture-content fr-element fr-view"
            style="padding:30px 0px 30px 50px;"
          >
            <a
              :href="articleDetail.content"
              target="_blank"
            >点击浏览：{{articleDetail.content}}</a>
          </div>

        </div>
      </div>

      <div
        class="audit_info"
        v-if='isShowAuditInfo'
      >
        <div class="audit_info_content">
          <div class="each_line">
            <span>稿件位置：</span>
            <span v-if='auditInfo.content && auditInfo.content.target_location'>{{auditInfo.content.target_location}}</span>
          </div>
          <div
            class="each_line"
            v-if='isShowauditOtherInfo'
          >
            <span>送&nbsp;审&nbsp;人：</span>
            <span v-if='auditInfo.req_user && auditInfo.req_user.username'>{{auditInfo.req_user.username}}</span>
            <span class="need_margin">审&nbsp;核&nbsp;人：</span>
            <span v-if='auditInfo.to_user && auditInfo.to_user.username'>{{auditInfo.to_user.username}}</span>
            <span class="need_margin">审核结果：</span>
            <span
              style="color:#6BD57C;"
              v-if='auditInfo.audit_status === "yes"'
            >已通过</span>
            <span
              style="color:#F56969;"
              v-if='auditInfo.audit_status === "no"'
            >未通过</span>
            <span
              style="color:#FFAD2F;"
              v-if='auditInfo.audit_status === "doing"'
            >审核中</span>
          </div>
          <div
            class="each_line"
            v-if='isShowauditOtherInfo'
          >
            <span>送审时间：</span>
            <span>{{auditInfo.time_request | formatTime}}</span>
            <span class="need_margin">审核时间：</span>
            <span>{{auditInfo.time_update | formatTime}}</span>
          </div>
          <div
            class="each_line"
            v-if='isShowauditOtherInfo'
          >
            <span>审核意见：</span>
            <div class="audit_advice">
              <span>{{auditInfo.audit_comment}}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="audit_info"
        v-if='isShowShareInfo'
      >
        <div class="audit_info_content">
          <div class="each_line">
            <span>稿件位置：</span>
            <span v-if='auditInfo.article && auditInfo.article.target_location'>{{auditInfo.article.target_location}}</span>
          </div>
          <div class="each_line">
            <span>分&nbsp;享&nbsp;人：</span>
            <span>{{auditInfo.shareUserName}}</span>
          </div>
          <div class="each_line">
            <span>分享备注：</span>
            <div class="audit_advice">
              <span>{{auditInfo.remarks}}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import * as api from '../../api'
export default {
  name: 'mspDetails',
  data () {
    return {
      fit: 'contain',
      alt: '图片加载失败',
      baseinfoRoleKey: []
    }
  },
  props: {
    articleDetail: {
      type: Object,
      required: true
    },
    isShowAuditInfo: {
      type: Boolean,
      required: true
    },
    auditInfo: {
      type: Object,
      required: true
    },
    isShowauditOtherInfo: {
      type: Boolean,
      required: true
    },
    isShowShareInfo: {
      type: Boolean,
      required: true
    }

  },
  created () {

  },
  components: {

  },
  computed: {
    isShowCurrentFiled () {
      return function (item) {
        if (item.key === 'reporter' || item.key === 'source' || item.key === 'tags' || item.key === 'keywords' || item.key === 'summary' || item.key === 'dialogue_text') {
          return false
        } else {
          return item.status
        }
      }
    },
    isShowOtherFileds () {
      return function (item) {
        if (this.baseinfoRoleKey.length > 0) {
          for (var i = 0; i < this.baseinfoRoleKey.length; i++) {
            if (this.baseinfoRoleKey[i].key === item) {
              return this.baseinfoRoleKey[i].status
              break;
            }
          }
        } else {
          return false
        }
      }
    }
  },
  mounted () {
    this.getBaseinfoRole()
  },
  destroyed () {

  },
  methods: {
    getBaseinfoRole () {
      var url = _API_ + "api/article/base_key/get";
      var option = {
        ...this.$store.getters.baseOption,
        params: {},
      };
      api
        ._post(url, option)
        .then((res) => {
          if (res.code == 200) {
            if (res.data) {
              this.baseinfoRoleKey = res.data;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.article_detail
  position relative
  z-index 1
  min-height 100%
  width calc(100% - 100px)
  border-radius 6px 6px 0 0
  background white
  color #606266
  font-size 14px
  .every_info_title
    color #303133 !important
  .every_info_label
    color #909399 !important
  .detail
    position relative
    box-sizing border-box
    padding 20px 0 20px 0
    .page_flag
      position absolute
      top 0px
      left 0
      display flex
    .flag_orign_button
      display flex
      align-items center
      margin-left 10px
      width 26px
      height 60px
      border-radius 0 0 6px 6px
      background #F56969
      color #fff
      text-align center
      font-size 14px
    .has_submit_button
      background #688EFF
    .detail_title
      box-sizing border-box
      padding 0 70px 30px 110px
      color #303133
      text-align center
      font-weight bold
      font-size 18px
    .detail_info
      box-sizing border-box
      padding-bottom 20px
      padding-left 30px
      border-bottom 1px solid #E8E8E8
      .pack_up
        display flex
        justify-content space-between
        align-items center
        .iconfont
          width 17px
          height 17px
      .every_info
        display flex
        box-sizing border-box
        padding-top 10px
        span
          flex none
          margin-left 70px
          letter-spacing 2px
        .label
          display inline-block
          flex none
          margin-left 0
          width 65px
          height 20px
          text-align justify
          &::after
            display inline-block
            width 100%
            height 0
            content ''
        .value
          margin-left 0
          min-width 40px
        .every_info_label
          margin-left 0px !important
          color #909399
        .msp_state
          box-sizing border-box
          margin-right 10px
          color #6BD57C
          span
            margin-left 0px
    .analyze
      box-sizing border-box
      padding 10px 30px 20px 30px
      border-bottom 1px solid #E8E8E8
      .every_info
        display flex
        box-sizing border-box
        padding-top 10px
        span
          letter-spacing 2px
        .every_info_content
          flex 1
        .label
          display inline-block
          flex none
          width 65px
          height 20px
          text-align justify
          &::after
            display inline-block
            width 100%
            height 0
            content ''
        img
          width 90px
          height 60px
    .article_detail_content
      box-sizing border-box
      width 100%
      .detail-content
        width 100%
        .each_detail_picture
          margin-bottom 30px
          .each_detail_picture_img
            display flex
            justify-content center
            margin-bottom 10px
          .each_detail_picture_descrip
            color #606266
            text-align center
            word-break break-all
            font-size 16px
    .audit_info
      box-sizing border-box
      padding 20px 30px 20px 30px
      .audit_info_content
        padding-top 20px
        border-top 1px solid #E8E8E8
        .each_line
          display flex
          margin-bottom 10px
          span
            input-title()
          .need_margin
            margin-left 30px
          .audit_advice
            flex 1
            word-break break-all
@media (min-width 992px)
  .fr-box.fr-document .fr-wrapper
    padding 0px
    min-width 0px
    background #fff
    text-align center
@media (min-width 992px)
  >>>.fr-box.fr-document .fr-wrapper .fr-element
    margin-top 0px !important
    margin-bottom 0 !important
    padding 0
    min-height 0px !important
    width 100%
@media (min-width 992px)
  .fr-box.fr-document
    min-width 0
@media (max-width 1600px)
  .article_detail
    font-size 12px !important
    .every_info
      span
        letter-spacing 1px !important
      .label
        width 40px !important
      .big_width_label
        width 52px !important
      .article_header_img
        margin-right 14px !important
        margin-left 0px !important
    .detail_info
      padding-left 14px !important
    .analyze
      padding 10px 14px 20px 14px !important
    .detail-content
      padding 30px !important
.base_field
  display flex
  flex-wrap wrap
  .each_base_field
    margin-right 30px
    margin-bottom 14px
    font-size 14px
    .base_field_title
      color #303133
    .base_field_content
      color #909399
</style>


